import Marquee from "react-fast-marquee";
import LinkUpload from "../../api/LinkUpload";
export default function HeaderBanner({ dataBackGrounds }) {

    // Lấy background đang active
    const activeBg = dataBackGrounds?.find((i) => i.IsActive) || null;

    // Không có data hoặc không có background active → ẩn
    if (!activeBg) return null;

    const { Logo, Image, Note, Color } = activeBg;

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 15,
                borderRadius: 12,
                padding: "10px 15px",
                overflow: "hidden",
                backgroundImage: Image ? `url(${LinkUpload(Image)})` : "none",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            {/* Logo (ẩn nếu không có) */}
            {Logo && (
                <img
                    src={LinkUpload(Logo)}
                    alt="logo"
                    style={{ height: 45, borderRadius: "50%", flexShrink: 0 }}
                />
            )}

            {/* Chữ chạy (ẩn nếu không có Note) */}
            {Note && (
                <Marquee speed={55} gradient={false}>
                    {Note.split("\n").map((line, index) => (
                        <span
                            key={index}
                            style={{
                                fontWeight: "bold",
                                color: Color || "yellow",
                                fontSize: "20px",
                                paddingRight: 50, // khoảng cách giữa các dòng chạy
                                whiteSpace: "pre", // giữ khoảng trắng, xuống dòng
                            }}
                        >
                            {line}
                        </span>
                    ))}
                </Marquee>
            )}

        </div>
    );
}
